import UserRole from "@/model/UserRole";

function roleHomePath(role: UserRole): string {
  return role === "ADMIN" ? "/companies" : "/";
}

export default roleHomePath;
